import { render, staticRenderFns } from "./SelectProjectTypeStep.vue?vue&type=template&id=7827f537&"
import script from "./SelectProjectTypeStep.vue?vue&type=script&lang=js&"
export * from "./SelectProjectTypeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports